module.exports = __webpack_public_path__ + "static/media/A.4fe85557.svg";